{
  "accounts": {
    "addToOrg": {
      "placeholder": "Select an organization",
      "subtitle": "The user keeps their account, studies and panels.",
      "title": "Add {{name}} to an organization"
    },
    "confirm": {
      "reactivateOrgBody": "The organization is shown in the app again and all its members can sign in again. Credits, shares and archived content are not restored.",
      "reactivateTitle": "Reactivate {{name}}",
      "reactivateUserBody": "{{name}} can sign in again. Credits, shares and archived content are not restored.",
      "removeBody": "{{name}} will lose access to {{org}}'s shared studies and panels. Their account stays active as an individual.",
      "removeTitle": "Remove from organization"
    },
    "credits": {
      "balance": "New balance",
      "confirm": "Save",
      "subtitle": "Set the credit balance or switch to unlimited.",
      "title": "Manage credits for {{name}}"
    },
    "drawer": {
      "created": "Created",
      "creditBalance": "Credit balance",
      "details": "Details",
      "id": "ID",
      "lastSignIn": "Last sign-in",
      "libraryPanel": "Foresight library",
      "members": "Members",
      "never": "Never",
      "noMembers": "No members yet.",
      "noPanels": "No panels yet.",
      "offboardedAt": "Offboarded",
      "ownedBy": "Owned by {{name}}",
      "panels": "Panels",
      "panelsCount": {
        "one": "{{count}} panel",
        "other": "{{count}} panels"
      }
    },
    "empty": "No accounts in {{region}} yet.",
    "emptySearch": "No accounts match your search.",
    "filters": {
      "all": "All",
      "individuals": "Individuals",
      "orgs": "Organizations",
      "showOffboarded": "Show offboarded"
    },
    "hiddenOtherRegion": {
      "one": "{{count}} account outside {{region}} is hidden. Switch region to manage it.",
      "other": "{{count}} accounts outside {{region}} are hidden. Switch region to manage them."
    },
    "menu": {
      "addMember": "Add member",
      "addToOrg": "Add to organization",
      "assignPanels": "Assign panels",
      "makeAdmin": "Make admin",
      "makeMember": "Make member",
      "makeOwner": "Make owner",
      "manageCredits": "Manage credits",
      "offboardOrg": "Offboard organization",
      "offboardUser": "Offboard user",
      "reactivate": "Reactivate",
      "removeFromOrg": "Remove from organization",
      "removeOwnerDisabled": "Transfer ownership to remove"
    },
    "orgsCount": {
      "one": "{{count}} organization",
      "other": "{{count}} organizations"
    },
    "roles": {
      "admin": "Admin",
      "member": "Member",
      "owner": "Owner"
    },
    "search": "Search organizations, users, emails…",
    "ssoEnabled": "SSO",
    "status": {
      "active": "Active",
      "offboarded": "Offboarded"
    },
    "stripeLinked": "Stripe",
    "subtitle": "{{orgs}} · {{users}} in {{region}}",
    "table": {
      "account": "Account",
      "created": "Created",
      "credits": "Credits",
      "lastActive": "Last active",
      "members": "Members",
      "membersCount": {
        "one": "{{count}} member",
        "other": "{{count}} members"
      },
      "panels": "Panels",
      "status": "Status",
      "type": "Type"
    },
    "title": "Accounts",
    "types": {
      "individual": "Individual",
      "org": "Organization"
    },
    "unlimitedCredits": "Unlimited",
    "usersCount": {
      "one": "{{count}} user",
      "other": "{{count}} users"
    }
  },
  "audienceBuilder": {
    "allGenders": "All genders",
    "countryCount": {
      "one": "{{count}} country",
      "other": "{{count}} countries",
      "zero": "Worldwide"
    },
    "extraFilters": {
      "one": "+{{count}} filter",
      "other": "+{{count}} filters",
      "zero": "No filters"
    }
  },
  "auth": {
    "subtitle": "Continuous market research for brands that move fast.",
    "tagline": "Simulate every audience, ",
    "taglineItalic": "get insights in minutes"
  },
  "console": {
    "actions": {
      "archive": "Archive",
      "delete": "Delete permanently",
      "seeRuns": "See runs",
      "transfer": "Transfer"
    },
    "adminBadge": "Admin",
    "chart": {
      "runsOverTime": "Runs over time",
      "runsOverTimeSubtitle": "Studies + adhoc questions launched",
      "statusBreakdown": "Status breakdown",
      "totalRuns": {
        "one": "{{count}} total run",
        "other": "{{count}} total runs"
      }
    },
    "confirm": {
      "archiveBody": "Are you sure you want to archive \"{{name}}\"?",
      "archiveTitle": "Archive item",
      "archiving": "Archiving…",
      "deleteBody": "Are you sure you want to permanently delete \"{{name}}\"? This cannot be undone.",
      "deleteTitle": "Delete permanently",
      "deleting": "Deleting…"
    },
    "custom": "Custom",
    "from": "From",
    "kpi": {
      "activeClients": "Active accounts",
      "adhoc": "Adhoc",
      "avgDuration": "Avg. duration",
      "completion": "Completion rate",
      "cost": "Cost",
      "respondents": {
        "one": "Respondent",
        "other": "Respondents"
      },
      "studies": "Studies",
      "successRate": "Success rate",
      "totalRuns": "Total runs"
    },
    "panel": {
      "loadMore": "Load more",
      "loading": "Loading…",
      "noAdhoc": "No adhoc questions found",
      "noAdhocSearch": "No questions match your search",
      "noStudies": "No studies found",
      "noStudiesSearch": "No studies match your search",
      "searchAdhoc": "Search questions…",
      "searchStudies": "Search studies…",
      "tabAdhoc": "Adhoc",
      "tabStudies": "Studies"
    },
    "runs": {
      "calls": {
        "one": "{{count}} call",
        "other": "{{count}} calls"
      },
      "characters": {
        "one": "{{value}} character",
        "other": "{{value}} characters"
      },
      "llm": "LLM",
      "noCost": "No cost recorded for this run.",
      "noRuns": "No runs yet.",
      "title": "Runs & costs",
      "tokens": {
        "one": "{{value}} token",
        "other": "{{value}} tokens"
      },
      "total": "Total",
      "translation": "Translation",
      "usageType": {
        "llm": {
          "chat": "Results chat",
          "conversation": "Persona conversation",
          "narrative": "Persona narrative",
          "other": "Other",
          "research": "Persona research",
          "simulation": "Persona simulation",
          "suggest": "Question suggestions",
          "summary": "AI summary",
          "visualization": "Chart generation"
        },
        "translation": {
          "content": "Content translation",
          "miscellaneous": "Interface labels",
          "other": "Other",
          "prompt": "Prompt translation",
          "summary": "Summary translation",
          "verbatim": "Verbatim translation"
        }
      }
    },
    "status": {
      "completed": "Completed",
      "draft": "Draft",
      "failed": "Failed",
      "queued": "Queued",
      "running": "Running"
    },
    "subtitle": "Platform overview — runs, clients & performance metrics",
    "table": {
      "adhocCount": "Adhoc",
      "avgDuration": "Avg.",
      "client": "Client",
      "clients": "Clients",
      "clientsCount": {
        "one": "{{count}} client",
        "other": "{{count}} clients"
      },
      "completion": "Completion",
      "cost": "Cost",
      "failedRuns": "Failed",
      "lastRun": "Last run",
      "membersCount": {
        "one": "{{count}} member",
        "other": "{{count}} members"
      },
      "studyCount": "Studies",
      "successRate": "Success",
      "successRuns": "Success",
      "totalRuns": "Runs"
    },
    "title": "Internal Console",
    "transfer": {
      "confirm": "Transfer",
      "external": "External",
      "noResults": "No users found.",
      "searchHint": "Search for a user by name or email.",
      "searchPlaceholder": "Search users…",
      "subtitle": "Reassign ownership to another user.",
      "title": "Transfer study",
      "transferring": "Transferring…"
    }
  },
  "credentials": {
    "copied": "Copied",
    "copy": "Copy",
    "email": "Email",
    "password": "Password",
    "subtitle": "Share these with the client. Passwords won't be shown again.",
    "title": "Sign-in details"
  },
  "errors": {
    "unknown": "Something went wrong. Please try again."
  },
  "forms": {
    "optional": "Optional",
    "org": {
      "addDomain": "Add",
      "credits": "Starting credits",
      "creditsHint": "Added to the credit balance on creation.",
      "domains": "Email domains",
      "domainsHint": "Only emails at these domains can join this organization.",
      "domainsRequired": "Add at least one domain.",
      "enrollment": {
        "automaticInvitation": "Auto-invite",
        "automaticSuggestion": "Suggest joining",
        "enterpriseSso": "SSO",
        "manualInvitation": "Manual invitation only"
      },
      "logo": "Logo",
      "logoHint": "PNG or JPG. Square images work best.",
      "logoRemove": "Remove",
      "logoReplace": "Replace",
      "logoUpload": "Upload image",
      "name": "Organization name",
      "region": "Region",
      "regionHint": "All members of this organization are assigned to this region.",
      "seatLimit": "Seat limit",
      "seatLimitHint": "Leave empty for unlimited members.",
      "slug": "Slug",
      "slugHint": "Used in URLs. Generated from the name.",
      "stripeCustomerId": "Stripe customer ID",
      "stripeCustomerIdHint": "Links billing to an existing Stripe customer.",
      "unlimitedCredits": "Unlimited credits"
    },
    "owner": {
      "existing": "Existing user",
      "new": "New user",
      "subtitle": "Becomes an organization admin and the default owner of assigned panels.",
      "title": "Owner"
    },
    "panels": {
      "assign": {
        "one": "Assign {{count}} panel",
        "other": "Assign {{count}} panels"
      },
      "assignSubtitle": "Give this client panels from the Foresight library.",
      "assignTitle": "Assign panels to {{name}}",
      "copy": "Copy into account",
      "copyDescription": "The client gets their own copy. Library updates are not propagated.",
      "default": "Default panel",
      "defaultHint": "Pre-selected when the client creates a study.",
      "defaultNone": "None",
      "library": "Panel library",
      "libraryEmpty": "No library panels in this region.",
      "librarySubtitle": "Panels in this region's library",
      "mode": "How to assign",
      "noMatches": "No panels match your search.",
      "orgAccess": "Organization access",
      "orgAccessHint": "What other members of the organization can do with these panels.",
      "owner": "Owner",
      "ownerHint": "Copies are owned by this member.",
      "ownerPlaceholder": "Select a member",
      "restricted": "Restricted",
      "searchPlaceholder": "Search panels…",
      "selectedCount": {
        "one": "{{count}} selected",
        "other": "{{count}} selected"
      },
      "share": "Share library panel",
      "shareDescription": "Read-only link to the library panel. Updates are reflected automatically.",
      "view": "Can view"
    },
    "placeholders": {
      "domain": "brand.com",
      "email": "jane.doe@brand.com",
      "firstName": "Jane",
      "lastName": "Doe",
      "memberEmail": "colleague@brand.com",
      "orgName": "Acme Beverages",
      "slug": "acme-beverages",
      "stripeCustomerId": "cus_…"
    },
    "regionLockHint": "Same as the region you're viewing. Change it from the top bar.",
    "required": "Required",
    "saving": "Saving…",
    "user": {
      "addMember": "Add member",
      "addMemberSubtitle": "New members get the organization's region.",
      "addMemberTitle": "Add member to {{name}}",
      "create": "Create user",
      "createSubtitle": "Creates the Clerk user in your current region.",
      "createTitle": "New user",
      "creditsHint": "Added to the user's credit balance. Org members use the org's credit balance.",
      "email": "Email",
      "emailDomain": "Use an email at {{domains}}.",
      "emailInvalid": "Enter a valid email.",
      "firstName": "First name",
      "lastName": "Last name",
      "noOrg": "No organization (individual)",
      "org": "Organization",
      "orgHint": "Leave empty for an individual account.",
      "regionFromOrg": "Inherited from {{name}}.",
      "role": "Role",
      "seatLimitReached": {
        "one": "This exceeds the seat limit of {{count}} member.",
        "other": "This exceeds the seat limit of {{count}} members."
      }
    },
    "userPicker": {
      "change": "Change",
      "inOrg": "Already in {{name}}",
      "noResults": "No users found.",
      "offboarded": "Offboarded",
      "otherDomain": "Email isn't at {{domains}}",
      "otherRegion": "Different region",
      "placeholder": "Search by name or email…"
    }
  },
  "misc": {
    "archived": "Archived",
    "cancel": "Cancel",
    "daysShort": "{{count}}d",
    "errorOccurred": "An error has occurred.",
    "hoursShort": "{{count}}h",
    "minutesShort": "{{count}}m",
    "retrying": "Retrying...",
    "secondsShort": "{{count}}s",
    "tryAgain": "Try Again",
    "unknown": "Unknown"
  },
  "nav": {
    "accounts": "Accounts",
    "onboardClient": "Onboard client",
    "usage": "Usage"
  },
  "notFound": {
    "goToHomeScreen": "Go to home screen",
    "notFound": "Can't find what you're looking for"
  },
  "offboard": {
    "confirmOrg": "Offboard organization",
    "confirmUser": "Offboard user",
    "contentLabel": "Studies, adhoc questions & panels",
    "deactivate": "Deactivate members",
    "deactivateDescription": "Ban sign-in for every member and revoke their sessions.",
    "delete": "Delete permanently",
    "deleteDescription": "Removes all content. This cannot be undone.",
    "detach": "Remove from organization only",
    "detachDescription": "Members keep individual accounts but lose shared access.",
    "effectsTitle": "What happens",
    "keep": "Keep (archived)",
    "keepDescription": "Archived and recoverable by a Foresight admin.",
    "membersLabel": "Members",
    "newOwner": "New organization owner",
    "newOwnerHint": "Required: this user owns the organization.",
    "newOwnerPlaceholder": "Select a member",
    "offboarding": "Offboarding…",
    "orgEffects": "Organization shares are revoked, remaining credits are forfeited and the organization is hidden from the app.",
    "orgSubtitle": "Closes the client's organization and its access.",
    "ownerBlocked": "This user is the only member of {{name}}. Offboard the organization instead.",
    "stats": {
      "credits": "Credits",
      "members": "Members",
      "panels": "Panels"
    },
    "staysInOrg": "This user stays in {{name}} as a deactivated member.",
    "title": "Offboard {{name}}",
    "typeToConfirm": "Type {{value}} to confirm",
    "userEffects": "Sign-in is disabled, active sessions are revoked, direct shares are removed and remaining credits are forfeited.",
    "userSubtitle": "Disables the account."
  },
  "onboard": {
    "addMember": "Add member",
    "back": "Back",
    "done": "Done",
    "doneSubtitle": "Accounts and panels are ready.",
    "doneTitle": "Client onboarded",
    "individualDescription": "A single user with their own credit balance.",
    "individualType": "Individual",
    "launch": "Onboard client",
    "memberErrors": "Fill in each member's first name, last name and a unique email at {{domains}}.",
    "members": "Members",
    "membersSubtitle": "Added to the organization.",
    "next": "Next",
    "noMembers": "No other members. You can add some later.",
    "orgDescription": "A team sharing a credit balance, panels and studies.",
    "orgType": "Organization",
    "owner": "Owner",
    "pasteAdd": "Add emails",
    "pasteList": "Paste list",
    "pastePlaceholder": "Paste emails separated by commas, spaces or new lines",
    "regionNote": "Everyone in this organization is created in {{region}}, the organization's region.",
    "review": {
      "edit": "Edit",
      "individual": "Individual",
      "name": "Name",
      "noPanels": "No panels assigned.",
      "org": "Organization",
      "unlimited": "Unlimited"
    },
    "running": "Onboarding…",
    "stepOf": "Step {{current}} of {{total}}",
    "steps": {
      "client": "Client",
      "panels": "Panels",
      "people": "People",
      "review": "Review"
    },
    "subtitle": "Creates everything in {{region}}.",
    "tasks": {
      "addMembers": {
        "one": "Adding {{count}} member",
        "other": "Adding {{count}} members"
      },
      "createOrg": "Creating {{name}} in {{region}}",
      "createOwner": "Creating owner account for {{name}}",
      "createUser": "Creating {{name}} in {{region}}",
      "panels": {
        "one": "Assigning {{count}} panel",
        "other": "Assigning {{count}} panels"
      }
    },
    "title": "Onboard client"
  },
  "panels": {
    "default": "Default"
  },
  "region": {
    "eu": "Europe",
    "switch": "Switch region",
    "switchBody": "You'll see and manage accounts in {{name}}.",
    "switchScope": "This changes your region across all of Foresight, not just the console: the Foresight app will also show {{name}} data, and any tokens you generate in the console will be for {{name}}.",
    "switchTitle": "Switch to {{name}}?",
    "switching": "Switching…",
    "us": "United States"
  }
}
